import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Home from "./Home";
import { Link, Route, Routes } from "react-router-dom";
import AboutUs from "./AboutUs";
import AccountancyServices from "./AccountancyServices";
import Jobs from "./Jobs";
import Contact from "./Contact";

const pages = ["Diensten", "Jobs", "Over ons", "Contact"];
const settings = ["Diensten", "Jobs", "Over ons", "Contact"];

function App() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar
        position="static"
        style={{ backgroundColor: "#444446", color: "#e4dbdc" }}
      >
        {" "}
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "#e4dbdc" }}>
                A-Census
              </Link>
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {/* <nav> */}
                <Link
                  to="/diensten"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">Diensten</Typography>
                  </MenuItem>{" "}
                </Link>
                <Link
                  to="/jobs"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">Jobs</Typography>
                  </MenuItem>
                </Link>
                <Link
                      to="/over-ons"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                
                      Over ons
            
                  </Typography>{" "}
                </MenuItem>        </Link>
                <Link
                      to="/contact"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
               
                      Contact
                  </Typography>{" "}
                </MenuItem>                    </Link>

                {/* </nav> */}
              </Menu>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "#e4dbdc" }}>
                A-Census
              </Link>
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              <Button
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                <Link
                  to="/diensten"
                  style={{ textDecoration: "none", color: "#e4dbdc" }}
                >
                  Diensten
                </Link>
              </Button>
              <Button
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                <Link
                  to="/jobs"
                  style={{ textDecoration: "none", color: "#e4dbdc" }}
                >
                  Jobs
                </Link>
              </Button>
              <Button
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                <Link
                  to="/over-ons"
                  style={{ textDecoration: "none", color: "#e4dbdc" }}
                >
                  Over ons
                </Link>
              </Button>
              <Button
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                <Link
                  to="/contact"
                  style={{ textDecoration: "none", color: "#e4dbdc" }}
                >
                  Contact
                </Link>
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <div style={{ height: "40%", overflow: "hidden", margin: 0 }}>
        <img src="acensus.jpg" style={{ width: "100vw", display: "block" }} />
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/over-ons" element={<AboutUs />} />
        <Route path="/diensten" element={<AccountancyServices />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}
export default App;
